module.exports = __webpack_public_path__ + "static/media/rh-map.12c8dfc4.jpg";